export default {
  velt: {
    openPanel: 'Abrir painel de comentários',
    closePanel: 'Fechar painel de comentários',
    panel: 'Painel de comentários',
    tabs: 'Abas do painel de comentários',
    comments: 'Comentários',
    settings: 'Configurações e permissões',
    dragOrTapComment: 'Arraste para adicionar um comentário ou toque para ver os comentários',
    assignComment: 'Atribuir comentário',
    markAsUnread: 'Marcar como não lido',
    markAsRead: 'Marcar como lido',
    unsubscribe: 'Cancelar inscrição',
    subscribe: 'Inscrever-se',
    deleteThread: 'Excluir tópico',
    editComment: 'Editar comentário',
    emptyPlaceholder: 'Dê um feedback, faça uma pergunta ou deixe uma nota para os membros da sua equipe',
    searchPlaceholder: 'Pesquisar comentários',
    commentPlaceholder: 'Comentar em {page}',
    replyPlaceholder: 'Responder....',
    filterPages: 'Páginas',
    filterAuthor: 'Autor',
    filterTagged: 'Marcados',
    statusOpen: 'Aberto',
    statusResolved: 'Resolvido',
    anonymous: 'Anônimo',
    settingsPanel: {
      title: 'Quem pode comentar?',
      everyoneLabel: 'Todos',
      restrictedLabel: 'Somente colaboradores convidados',
      emailsLabel: 'E-mails',
      emailsPlaceholder: 'Adicione um e-mail e pressione Enter',
    },
  },
}
